export default "__VITE_ASSET__646b299b__"